export default __webpack_public_path__ + "static/banner-bg-d3f5beee4be0825ab98f5f5dd1ce9a46.jpg";